import { render, staticRenderFns } from "./EditionHistory.vue?vue&type=template&id=d6271194&scoped=true"
import script from "./EditionHistory.vue?vue&type=script&lang=js"
export * from "./EditionHistory.vue?vue&type=script&lang=js"
import style0 from "./EditionHistory.vue?vue&type=style&index=0&id=d6271194&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6271194",
  null
  
)

export default component.exports